var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      key: "menutools-" + _vm.curkey,
      staticClass: "pa-3 elevation-0",
      attrs: {
        left: "",
        transition: "slide-x-reverse-transition",
        "close-on-content-click": true,
        "close-on-click": true,
        "offset-x": "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _vm.curkey | _vm.showMore(_vm.showMore)
                ? _c(
                    "v-btn",
                    _vm._g(
                      {
                        key: "btns--" + _vm.curkey,
                        attrs: { icon: "", disabled: _vm.disabled },
                      },
                      on
                    ),
                    [
                      _c("i", { staticClass: "material-icons-round" }, [
                        _vm._v("more_vert"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showMenu,
        callback: function ($$v) {
          _vm.showMenu = $$v
        },
        expression: "showMenu",
      },
    },
    [
      _c(
        "v-list",
        {
          attrs: {
            dense: "",
            tile: "",
            flat: "",
            "min-width": "130",
            elevation: 0,
          },
        },
        [
          _vm.viewBtn
            ? _c(
                "v-list-item",
                {
                  attrs: { tile: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onTriger("view")
                    },
                  },
                },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t(_vm.viewText))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.editBtn
            ? _c(
                "v-list-item",
                {
                  attrs: { tile: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onTriger("edit")
                    },
                  },
                },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t(_vm.editText))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.delBtn
            ? _c(
                "v-list-item",
                {
                  attrs: { tile: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onTriger("delete")
                    },
                  },
                },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t(_vm.delText))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.otherBtn
            ? _c(
                "v-list-item",
                {
                  attrs: { tile: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onTriger("other")
                    },
                  },
                },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t(_vm.otherText))),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }